import React from 'react'
import { inject, observer } from 'mobx-react'
import UserShapefileListContainer from './UserShapefileListContainer'
import UserShapefileLevelList from './UserShapefileLevelList'

const UserShapefilePane = ({ userShapefileList }) => (
  userShapefileList.selectedFile === null
    ? (
      <UserShapefileListContainer
        userShapefileList={userShapefileList}
      />
      )
    : (
      <UserShapefileLevelList
        userShapefileList={userShapefileList}
        shapefile={userShapefileList.selectedFile}
      />
      )
)

export default inject('selectionStore')(
  observer(UserShapefilePane)
)
